import SearchIcon from "@mui/icons-material/Search";
import {
  Alert,
  Box,
  Button,
  InputAdornment,
  List,
  ListItemButton,
  TablePagination,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { loginUser } from "../services/authService";

export default function SelectUserPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const mode = location.state?.mode || "login"; // výchozí login
  const [searchTerm, setSearchTerm] = useState("");

  // pagination state
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  const users = useMemo(() => location.state?.users || [], [location.state]);

  useEffect(() => {
    if (!users.length) {
      navigate("/zvk");
    }
  }, [users, navigate]);

  // Funkce pro obsluhu výběru konkrétního uživatele
  const handleSelect = async (user) => {
    if (mode === "register") {
      // Pokud je režim registrace, přesměrujeme na registrační stránku s uživatelskými údaji
      navigate("/register", {
        replace: true,
        state: {
          email: location.state?.email || user.email,
          cisloOdberatele: user.cisloOdberatele,
          mode: "register",
          isVerified: true,
        },
      });
      return;
    } else if (mode === "forgot") {
      navigate("/new-password", {
        replace: true,
        state: {
          email: user.email,
          cisloOdberatele: user.cisloOdberatele,
          isVerified: true,
        },
      });
      return;
    } else {
      const result = await loginUser(user.cisloOdberatele);
      if (result.success) {
        navigate("/email-password", {
          replace: true,
          state: { cisloOdberatele: user.cisloOdberatele },
        });
      }
    }
  };

  const filtredUsers = useMemo(() => {
    return users?.filter((user) => {
      const hay = `${user.cisloOdberatele} ${user.nazev}`.toLowerCase();
      if (!hay.includes(searchTerm.toLowerCase())) return false;

      return true;
    });
  }, [users, searchTerm]);

  const paginatedUsers = useMemo(() => {
    // slice podle aktuální stránky
    return filtredUsers.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [filtredUsers, page, rowsPerPage]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box
      sx={{
        maxWidth: "500px",
        margin: "10px auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.7rem" }, // responsive font size
          mt: 4,
          mb: 2,
        }}
      >
        Vyberte odběratele
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Nalezeno několik uživatelů s tímto emailem. Vyberte správného uživatele.
      </Alert>

      {users?.length > 10 && (
        <TextField
          label="Hledat"
          variant="outlined"
          margin="normal"
          value={searchTerm}
          onChange={handleSearchChange}
          sx={{ maxWidth: "250px", margin: "0px auto" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      )}

      <List>
        {paginatedUsers.map((user, index) => (
          <ListItemButton
            key={index}
            sx={(theme) => ({
              display: "flex",
              flexDirection: "row",
              border: "1px solid",
              borderColor: "primary.main",
              borderRadius: 2,
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor:
                  theme.palette.mode === "light"
                    ? "#f0f8ff" // jemně modrá pro světlý motiv
                    : theme.palette.action.hover, // defaultní „hover“ pro tmavý
                borderColor: "primary.dark",
              },
              mb: 1,
            })}
          >
            {/* Tady zobrazte relevantní pole uživatele, např. cisloOdberatele, nazev atd. */}
            <Typography sx={{ flex: 1 }}>
              Odběratel: <strong>{user.cisloOdberatele}</strong> (
              {user.nazev || "bez názvu"})
            </Typography>

            <Button
              variant="contained"
              sx={{ marginLeft: "15px" }}
              onClick={() => handleSelect(user)}
            >
              Vybrat
            </Button>
          </ListItemButton>
        ))}
      </List>

      {filtredUsers?.length > rowsPerPage && (
        <TablePagination
          component="div"
          count={users.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[]}
        />
      )}

      <Button
        variant="contained"
        sx={{ margin: "0 auto" }}
        onClick={() => navigate("/")}
      >
        Zpět k přihlášení
      </Button>
    </Box>
  );
}
